import { MessageSquare, UserRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DIRECT_CHAT_ACTIONS } from "@/modules/despacho/despachoChatUi";

/**
 * Acciones rápidas por auxiliar — abre chat directo con mensaje sugerido.
 * @param {{ onAction: (actionId: string, context?: object) => void, pendingContext?: object|null, compact?: boolean }} props
 */
export default function DespachoAuxiliarQuickActions({ onAction, pendingContext = null, compact = false }) {
  return (
    <div
      className={`flex flex-wrap gap-1.5 ${compact ? "mt-2" : "mt-3"}`}
      data-testid="despacho-auxiliar-quick-actions"
    >
      {DIRECT_CHAT_ACTIONS.map((action) => (
        <Button
          key={action.id}
          type="button"
          variant={action.id === "chat_directo" ? "default" : "outline"}
          size="sm"
          className={
            action.id === "chat_directo"
              ? "rounded-sm h-7 text-[10px] px-2 bg-[#0F2D5C] hover:bg-[#0a2248]"
              : "rounded-sm h-7 text-[10px] px-2"
          }
          onClick={() => onAction(action.id, pendingContext || undefined)}
          data-testid={`despacho-quick-${action.id}`}
        >
          {action.id === "chat_directo" ? (
            <MessageSquare className="w-3 h-3 mr-1" aria-hidden />
          ) : null}
          {action.label}
        </Button>
      ))}
    </div>
  );
}

export function DespachoDirectChatHeader({ auxiliarNombre, pendingContext, onClose }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-2 border-b border-slate-200 pb-3">
      <div className="min-w-0">
        <p className="text-xs font-bold text-[#0F2D5C] m-0 flex items-center gap-1.5">
          <UserRound className="w-3.5 h-3.5 shrink-0" aria-hidden />
          Chat directo — {auxiliarNombre}
        </p>
        <p className="text-[10px] text-slate-500 m-0 mt-0.5">
          Seguimiento individual · visible solo para dueño/supervisor y el auxiliar.
        </p>
        {pendingContext?.titulo ? (
          <p className="text-[10px] text-slate-600 m-0 mt-1">
            Contexto: <span className="font-medium">{pendingContext.titulo}</span>
            {pendingContext.cliente ? ` — ${pendingContext.cliente}` : ""}
          </p>
        ) : null}
      </div>
      {onClose ? (
        <Button type="button" variant="ghost" size="sm" className="h-7 text-[10px] rounded-sm" onClick={onClose}>
          Cerrar
        </Button>
      ) : null}
    </div>
  );
}
